import { render } from "./SectionPS.vue?vue&type=template&id=4baa6e6a&scoped=true"
const script = {}

import "./SectionPS.vue?vue&type=style&index=0&id=4baa6e6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baa6e6a"]])

export default __exports__